import { render, staticRenderFns } from "./MappingReview.vue?vue&type=template&id=dd2be784&scoped=true&"
import script from "./MappingReview.vue?vue&type=script&lang=ts&"
export * from "./MappingReview.vue?vue&type=script&lang=ts&"
import style0 from "./MappingReview.vue?vue&type=style&index=0&id=dd2be784&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2be784",
  null
  
)

export default component.exports